import { createFileRoute } from '@tanstack/react-router'
import { generateQrCodeSvgXml } from '@/src/server/lib/qrcode'
import { logger } from '@/src/server/lib/logger'

/**
 * QR Code Generation API
 * 
 * Generates QR codes server-side and returns them as SVG images
 * 
 * Query Parameters:
 *   - url: The URL to encode (required)
 *   - size: Width/height in pixels (optional, default: 200)
 *   - icon: Include icon in center (optional, default: true)
 */

export const Route = createFileRoute('/api/qrcode')({})

export const GET = async ({ request }: { request: Request }) => {
  try {
    const url = new URL(request.url)
    const targetUrl = url.searchParams.get('url')
    const size = parseInt(url.searchParams.get('size') || '200', 10)
    const withIcon = url.searchParams.get('icon') !== 'false'

    if (!targetUrl) {
      return new Response(
        JSON.stringify({ error: 'Missing required parameter: url' }),
        { 
          status: 400,
          headers: { 'Content-Type': 'application/json' }
        }
      )
    }

    // Validate size
    if (size < 50 || size > 1000) {
      return new Response(
        JSON.stringify({ error: 'Size must be between 50 and 1000' }),
        { 
          status: 400,
          headers: { 'Content-Type': 'application/json' }
        }
      )
    }

    // Generate QR code SVG
    const svg = await generateQrCodeSvgXml(targetUrl, withIcon, { width: size })

    return new Response(svg, {
      status: 200,
      headers: {
        'Content-Type': 'image/svg+xml',
        'Cache-Control': 'public, max-age=31536000, immutable',
      },
    })
  } catch (error) {
    logger.error({ error }, 'Failed to generate QR code')
    return new Response(
      JSON.stringify({ error: 'Failed to generate QR code' }),
      { 
        status: 500,
        headers: { 'Content-Type': 'application/json' }
      }
    )
  }
}
